import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=7f945279"
import script from "./lang-switch.vue?vue&type=script&lang=js"
export * from "./lang-switch.vue?vue&type=script&lang=js"
import style0 from "./lang-switch.vue?vue&type=style&index=0&id=7f945279&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports